const selectStyler = () => {

    const select = $('.select select');

    if (select.length) {
        select.styler({
            selectSmartPositioning : false,
            selectSearch           : false,
            singleSelectzIndex     : '3'
        });

        $(document).on('click', '.select', function(){
            const dropdown = $(this).find('ul');
            if ( !dropdown.hasClass('ps') ) {
                const customScrollBar = new CustomScrollbar(dropdown);
            }
        });
    }

}